import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('DeviceProductGroupFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getDeviceProductGroupList: function () {
            return $http.get(settings.ApiURL + settings.DeviceProductGroupURL);
        },
        getDeviceProductGroupByID: function (id) {
            return $http.get(settings.ApiURL + settings.DeviceProductGroupURL + "/" + id);
        },
        getProductDropdown: function () {
            return $http.get(settings.ApiURL + settings.ProductURL + "/dropdown/0");
        },
        saveDeviceProductGroup: function (deviceProductGroup) {
            return $http.put(settings.ApiURL + settings.DeviceProductGroupURL, deviceProductGroup);
        },
        deleteDeviceProductGroup: function (id) {
            return $http.delete(settings.ApiURL + settings.DeviceProductGroupURL + "/" + id);
        }
    };
}]);

app.controller('DeviceProductGroupController', ['$q', '$scope', 'DeviceProductGroupFactory', '$rootScope', 'settings', 'masterFactory', '$uibModal',
    function ($q, $scope, DeviceProductGroupFactory, $rootScope, settings, masterFactory, $uibModal) {
        $rootScope.pageTitle = "Device Product Group";
        $scope.deviceProductGroupList = [];
        $scope.deviceProductGroup = {};
        $scope.productDropdown = [];
        $scope.newDeviceProductGroup = {};
        $scope.error = "";
        $scope.productGridError = "";
        $scope.modelState = [];
        $scope.isFormVisible = false;
        $scope.isNewDeviceProductGroup = false;
        $scope.isAssignedVehicleSelected = false;
        $scope.isUnassignedVehicleSelected = false;
        $scope.isProductsGridCollapsed = false;
        $scope.isVehiclessGridCollapsed = false;        
        $scope.pageSize = 20;

        // Initialization - this runs on load
        var init = function (pageIndex) {
            masterFactory.verifyAuthentication();

            $('#loadingModal').modal({ backdrop: 'static' });
            $q.all([
                DeviceProductGroupFactory.getProductDropdown().success(function (data) {
                    $scope.productDropdown = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                DeviceProductGroupFactory.getDeviceProductGroupList().success(function (data) {
                    $scope.deviceProductGroupList = data;
                    $scope.refreshGrid(pageIndex, null);
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                })
            ]).then(function () {

            });
        };

        init(0);

        // Grid renderers
        $scope.refreshGrid = function (PageIndex, Key) {
            $('#gridDeviceProductGroup').dxDataGrid({
                dataSource: {
                    store: {
                        data: $scope.deviceProductGroupList,
                        type: 'array',
                        key: 'Id'
                    }
                },
                columns: [
                   { caption: 'Group No', dataField: 'Id', cssClass: 'Id', dataType: 'number', alignment: 'center', width: 150 },
                   {
                       caption: 'Group Name', dataField: 'Name', cssClass: 'Name', dataType: 'string', alignment: 'center',
                       cellTemplate: function (container, options) {
                           $('<span />')
                           .text(options.data.Name)
                           .appendTo(container);
                           container.addClass('grid-cell-align-left');
                       }
                   }
                ],
                contentReadyAction: grdReadyAction,
                filterRow: { visible: true },
                groupPanel: { visible: false, },
                noDataText: "No Device Product Group Found",
                pager: { showPageSizeSelector: true, allowedPageSizes: [10, 20, 30] },
                paging: { pageSize: $scope.pageSize, pageIndex: PageIndex },
                rowAlternationEnabled: false,
                selection: { mode: 'single' },
                showColumnLines: true,
                showRowLines: false,
                showBorders: true,
                selectionChanged: function (selectedRowsInfo) {
                    if (selectedRowsInfo.selectedRowsData[0] != null) {
                        $('#loadingModal').modal({ backdrop: 'static' });
                        DeviceProductGroupFactory.getDeviceProductGroupByID(selectedRowsInfo.selectedRowsData[0].Id).success(function (data) {
                            $scope.deviceProductGroup = angular.copy(data);
                            $scope.refreshProductsGrid();
                            $scope.refreshAssignedVehiclesGrid();
                            $scope.refreshUnAssignedVehiclesGrid();
                            $scope.isFormVisible = true;
                            $scope.isDeleteVisible = true;
                            $scope.isNewdeviceProductGroup = false;
                            ToggleYellowToGreen();
                            $rootScope.pageTitle = "Device Product Group";
                        }).error(function (data, status) {
                            masterFactory.setError(status, data, $scope);
                        }).finally(function () {
                            $('#loadingModal').modal('hide');
                        });
                    }
                }
            });

            if (Key != null && Key > 0) {
                var dataGrid = $('#gridDeviceProductGroup').dxDataGrid('instance');
                (dataGrid as unknown as FacnmDx).selectRows([Key]);
            }
        };

        $scope.refreshProductsGrid = function () {
            $('#gridProducts').dxDataGrid({
                dataSource: $scope.deviceProductGroup.AssignedProducts,
                columns: [
                    {
                        caption: 'Product Name on Register', dataField: 'ProductNameOnDevice', validationRules: [{ type: "required" }],
                        dataType: 'string', alignment: 'center', width: '25%'
                    },
                    {
                        caption: 'Product ID on Register', dataField: 'ProductNameNumber', validationRules: [{ type: "required" }],
                        dataType: 'string', width: '25%', alignment: 'center'
                    },
                    {
                        caption: 'Product Unit', dataField: 'UnitOfProduct', validationRules: [{ type: "required" }],
                        dataType: 'string', width: '10%', alignment: 'center'
                    },
                    {
                        caption: 'Product Number - Name', dataField: 'ProductId', validationRules: [{ type: "required" }],
                        dataType: 'number', width: '20%', alignment: 'center',
                        lookup: {
                            dataSource: $scope.productDropdown,
                            displayExpr: 'ProductName',
                            valueExpr: 'Id'
                        }
                    }
                ],
                editing: { editMode:'cell', editEnabled: true, insertEnabled: true, removeEnabled: true },
                filterRow: { visible: false },
                groupPanel: { visible: false, },
                height: 470,
                noDataText: "No Products Found",
                pager: { showPageSizeSelector: true, allowedPageSizes: [10, 20, 30] },
                paging: { pageSize: 30 },
                sorting: { mode: 'none' },
                rowAlternationEnabled: false,
                rowInserted: function (rowInfo) {
                    rowInfo.data.Id = -1;
                },
                rowInserting: onProductGridRowInserting,
                rowUpdating: onProductGridRowUpdating,                
                selection: { mode: 'single' },
                showColumnLines: true,
                showRowLines: false,
                showBorders: true
            });

            var grd = document.getElementById("gridProducts");
            if (grd.getElementsByClassName("dx-datagrid-header-panel")[0].childNodes.length == 1)
                $('<span > Products </span>').appendTo(grd.getElementsByClassName("dx-datagrid-header-panel")[0]);
        };

        function onProductGridRowInserting(e) {
            $scope.productGridError = "";
            if (!IsUndefinedOrNull(e.data)) {
                if (IsUndefinedOrNull(e.data.ProductNameOnDevice) || IsUndefinedOrNull(e.data.ProductNameNumber) ||
                    IsUndefinedOrNull(e.data.UnitOfProduct) || IsUndefinedOrNull(e.data.ProductId)) {
                    $scope.productGridError = "Please enter all values for new record.";
                    e.cancel = true;
                    return;
                }
                else $scope.productGridError = "";
            }
            else {
                $scope.productGridError = "Please enter all values for new record.";
                e.cancel = true;
                return;
            }
        };

        function onProductGridRowUpdating(e) {
            $scope.productGridError = "";
            if (!IsUndefinedOrNull(e)) {
                if (IsUndefinedOrNull(e.newData.ProductNameOnDevice) || IsUndefinedOrNull(e.newData.ProductNameNumber) ||
                    IsUndefinedOrNull(e.newData.UnitOfProduct) || IsUndefinedOrNull(e.newData.ProductId) ||
                    e.newData.ProductNameOnDevice == "" || e.newData.ProductNameNumber == "" || 
                    e.newData.UnitOfProduct == "" || e.newData.ProductId == "") {
                    $scope.productGridError = "Please enter all values to update record.";
                    e.cancel = true;
                    return;
                }
                else $scope.productGridError = "";
            }
            else {
                $scope.productGridError = "Please enter all values to update record.";
                e.cancel = true;
                return;
            }
        };        

        function getProductDropdownDisplayName(ds) {
            return ds.ProductName;
        };

        $scope.refreshAssignedVehiclesGrid = function () {
            $scope.isAssignedVehicleSelected = false;

            $('#gridAssignedVehicles').dxDataGrid({
                dataSource: $scope.deviceProductGroup.AssignedVehicles,
                columns: [
                    { caption: 'Vehicle Id', dataField: 'Id', cssClass: 'Id', dataType: 'number', visible: false },
                    {
                        caption: 'Device Id - Name', dataField: 'DeviceId', dataType: 'string', alignment: 'center',
                        cellTemplate: function (container, options) {
                            var devicedetails = "";
                            if (options.data.DeviceId != 0) devicedetails = devicedetails + options.data.DeviceId + " - ";
                            if (options.data.DeviceName != null) devicedetails = devicedetails + options.data.DeviceName;
                            $('<span />').text(devicedetails).append("</br>").appendTo(container);
                            container.addClass('grid-cell-align-left');
                        },
                        calculateCellValue: function(data){
                            return data.DeviceId + " - " + data.DeviceName;
                        },
                        calculateFilterExpression: function (filterValue, selectedFilterOperation) {
                            return [this.calculateCellValue, selectedFilterOperation || 'contains', filterValue];
                        }
                    },
                    { alignment: 'center', caption: 'Vehicle No', dataField: 'VehicleNumber', cssClass: 'VehicleNumber', dataType: 'string' },
                    {
                        alignment: 'center', caption: 'License Plate', dataField: 'LicensePlate', cssClass: 'LicensePlate', dataType: 'string',
                        width: 150,
                        cellTemplate: function (container, options) {
                            $('<span />')
                           .text(options.data.LicensePlate)
                           .appendTo(container);
                            container.addClass('grid-cell-align-left');
                        }
                    }
                ],
                contentReadyAction: resetSelectionColumn,
                filterRow: { visible: true },
                groupPanel: { visible: false, },
                height: 470,
                paging: { pageSize: 10 },
                pager: { showPageSizeSelector: false },
                rowAlternationEnabled: false,
                selection: { mode: 'multiple' },
                showColumnLines: true,
                showRowLines: false,
                showBorders: true,
                selectionChanged: function (selectedRowsInfo) {
                    if (selectedRowsInfo.selectedRowsData.length > 0) {
                        $scope.isAssignedVehicleSelected = true;
                    }
                    else {
                        $scope.isAssignedVehicleSelected = false;
                    }
                }
            });
        };

        $scope.refreshUnAssignedVehiclesGrid = function () {
            $scope.isUnassignedVehicleSelected = false;

            $('#gridUnAssignedVehicles').dxDataGrid({
                dataSource: $scope.deviceProductGroup.UnAssignedVehicles,
                columns: [
                    { caption: 'Vehicle Id', dataField: 'Id', dataType: 'number', cssClass: 'number', visible: false },
                    {
                        caption: 'Device Id - Name', dataField: 'DeviceId', cssClass: 'DeviceId', dataType: 'string', alignment: 'center',
                        cellTemplate: function (container, options) {
                            var devicedetails = "";
                            if (options.data.DeviceId != 0) devicedetails = devicedetails + options.data.DeviceId + " - ";
                            if (options.data.DeviceName != null) devicedetails = devicedetails + options.data.DeviceName;
                            $('<span />').text(devicedetails).append("</br>").appendTo(container);
                            container.addClass('grid-cell-align-left');
                        },
                        calculateCellValue: function(data){
                            return data.DeviceId + " - " + data.DeviceName;
                        },
                        calculateFilterExpression: function (filterValue, selectedFilterOperation) {
                            return [this.calculateCellValue, selectedFilterOperation || 'contains', filterValue];
                        }
                    },
                    { alignment: 'center', caption: 'Vehicle No', dataField: 'VehicleNumber', cssClass: 'VehicleNumber', dataType: 'string' },
                    {
                        alignment: 'center', caption: 'License Plate', dataField: 'LicensePlate', cssClass: 'LicensePlate', dataType: 'string',
                        width: 150,
                        cellTemplate: function (container, options) {
                            $('<span />')
                           .text(options.data.LicensePlate)
                           .appendTo(container);
                            container.addClass('grid-cell-align-left');
                        }
                    }
                ],
                contentReadyAction: resetSelectionColumn,
                filterRow: { visible: true },
                groupPanel: { visible: false },
                height: 470,
                paging: { pageSize: 10 },
                pager: { showPageSizeSelector: false },
                rowAlternationEnabled: false,
                selection: { mode: 'multiple' },
                showColumnLines: true,
                showRowLines: false,
                showBorders: true,
                selectionChanged: function (selectedRowsInfo) {
                    if (selectedRowsInfo.selectedRowsData.length > 0) {
                        $scope.isUnassignedVehicleSelected = true;
                    }
                    else {
                        $scope.isUnassignedVehicleSelected = false;
                    }
                }
            });
        };
       
        //Button click functions
        $scope.addNewDeviceProductGroup = function () {
            $rootScope.pageTitle = "New Device Product Group";
            DeviceProductGroupFactory.getDeviceProductGroupByID(0).success(function (data) {
                $scope.deviceProductGroup = angular.copy(data);
                $scope.newDeviceProductGroup = angular.copy(data);                
                $scope.refreshProductsGrid();
                $scope.refreshAssignedVehiclesGrid();
                $scope.refreshUnAssignedVehiclesGrid();
                $scope.isFormVisible = true;
                $scope.isDeleteVisible = false;
                $scope.isNewDeviceProductGroup = true;
                ToggleGreenToYellow();
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        };

        $scope.confirmDeleteEntity = function () {
            $('#DeleteModal').modal({ backdrop: 'static' });
        };

        $scope.deleteEntity = function (value) {
            if (value == 0) {
                $('#DeleteModal').modal('hide');
            }
            else if (value == 1) {
                DeviceProductGroupFactory.deleteDeviceProductGroup($scope.deviceProductGroup.Id).success(function (data) {
                    DeviceProductGroupFactory.getDeviceProductGroupList().success(function (data) {
                        var dataGrid = $('#gridDeviceProductGroup').dxDataGrid('instance');
                        var pageIndex = dataGrid.pageIndex();
                        $scope.pageSize = dataGrid.pageSize();
                        $scope.deviceProductGroupList = data;
                        $scope.cancelForm();
                        $scope.refreshGrid(pageIndex, null);
                    }).error(function () {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Device Product Group successfully' });
                    });
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#DeleteModal').modal('hide');
                });
            }
        };

        $scope.cancelForm = function () {
            var dataGrid = $('#gridDeviceProductGroup').dxDataGrid('instance');
            dataGrid.clearSelection();
            $scope.isFormVisible = false;
            $scope.deviceProductGroupForm.$submitted = false;
            $scope.closeModelStateErrors();
            $scope.closeAlert();
            $scope.closeProductGridAlert();
        };

        $scope.reset = function (type) {
            if (type == 'update') { // get db bankaccount and set to scope.bankaccount.
                $('#loadingModal').modal({ backdrop: 'static' });
                DeviceProductGroupFactory.getDeviceProductGroupByID($scope.deviceProductGroup.Id).success(function (data) {
                    $scope.deviceProductGroup = data;
                    $scope.refreshProductsGrid();
                    $scope.refreshAssignedVehiclesGrid();
                    $scope.refreshUnAssignedVehiclesGrid();
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                });
            }
            else {
                angular.copy($scope.newDeviceProductGroup, $scope.deviceProductGroup);
                $scope.refreshProductsGrid();
                $scope.refreshAssignedVehiclesGrid();
                $scope.refreshUnAssignedVehiclesGrid();
            }

            $scope.deviceProductGroupForm.$setPristine();
            $scope.deviceProductGroupForm.$submitted = false;
            $scope.closeModelStateErrors();
            $scope.closeAlert();
            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Device Product Group details were reset' });
        };

        $scope.submitForm = function () {            
            if ($scope.deviceProductGroupForm.$valid) {
                if (ValidateFormData()) {
                    $scope.saveDeviceProductGroup();
                    $scope.closeAlert();
                }                
            }
        };

        function ValidateFormData() {
            // 1. There must be atleast one Product line item.
            if ($scope.deviceProductGroup.AssignedProducts == null || $scope.deviceProductGroup.AssignedProducts.length == 0) {
                $scope.error = "Please add atleast one product in Products Grid";
                return false;
            }
                
            //2. There must be atleaset one assigned vehicle.
            if ($scope.deviceProductGroup.AssignedVehicles == null || $scope.deviceProductGroup.AssignedVehicles.length == 0) {
                $scope.error = "Please add atleast one Vehicle in Vehicles Grid";
                return false;
            }
            return true;
        };

        $scope.saveDeviceProductGroup = function () {
            var pageindex, id;
            $scope.closeModelStateErrors();
            //$('#loadingModal').modal({ backdrop: 'static' });
            DeviceProductGroupFactory.saveDeviceProductGroup($scope.deviceProductGroup).success(function (deviceProductGroupId) {
                DeviceProductGroupFactory.getDeviceProductGroupList().success(function (data) {
                    var dataGrid = $('#gridDeviceProductGroup').dxDataGrid('instance');
                    $scope.pageSize = dataGrid.pageSize();
                    pageindex = dataGrid.pageIndex();
                    $scope.deviceProductGroupList = data;
                    if ($scope.deviceProductGroup.Id > 0) {
                        $scope.refreshGrid(pageindex, $scope.deviceProductGroup.Id);
                        $scope.refreshProductsGrid();
                        $scope.refreshAssignedVehiclesGrid();
                        $scope.refreshUnAssignedVehiclesGrid();
                    }
                    else {
                        $scope.cancelForm();
                        $scope.refreshGrid(pageindex, null);
                    }
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function (data) {
                    if ($scope.deviceProductGroup.Id > 0) {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Device Product Group successfully' });
                    }
                    else {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Device Product Group successfully' });
                    }
                });
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                //$('#loadingModal').modal('hide');
            });
        };

        // Selecting and Unselecting grid items on details panel
        $scope.assignVehicles = function () {
            var dataGrid1 = $('#gridUnAssignedVehicles').dxDataGrid('instance');
            var dataGrid2 = $('#gridAssignedVehicles').dxDataGrid('instance');
            var selectedRows = dataGrid1.getSelectedRowsData();
            var i = 0; var len = selectedRows.length;
            for (; i < len; i++) {
                var prd = $scope.filter($scope.deviceProductGroup.AssignedVehicles, selectedRows[i].Id);
                $scope.deviceProductGroup.UnAssignedVehicles.splice($scope.deviceProductGroup.UnAssignedVehicles.indexOf(selectedRows[i]), 1);
                if (prd == null) {
                    $scope.deviceProductGroup.AssignedVehicles.push(selectedRows[i]);
                }
            }
            $scope.refreshAssignedVehiclesGrid();
            $scope.refreshUnAssignedVehiclesGrid();
            dataGrid1.clearSelection();
            dataGrid1.refresh();
            dataGrid2.refresh();
        };

        $scope.unassignVehicles = function () {
            var dataGrid1 = $('#gridAssignedVehicles').dxDataGrid('instance');
            var dataGrid2 = $('#gridUnAssignedVehicles').dxDataGrid('instance');
            var selectedRows = dataGrid1.getSelectedRowsData();
            var i = 0; var len = selectedRows.length;
            for (; i < len; i++) {
                var prd = $scope.filter($scope.deviceProductGroup.UnAssignedVehicles, selectedRows[i].Id);
                $scope.deviceProductGroup.AssignedVehicles.splice($scope.deviceProductGroup.AssignedVehicles.indexOf(selectedRows[i]), 1);
                if (prd == null) {
                    $scope.deviceProductGroup.UnAssignedVehicles.push(selectedRows[i]);
                }                
            }
            $scope.refreshAssignedVehiclesGrid();
            $scope.refreshUnAssignedVehiclesGrid();
            dataGrid1.clearSelection();
            dataGrid2.refresh();
        };

        // Helping functions and events
        $(window).resize(function () {
            onWindowResize('#gridDeviceProductGroup', settings.GridMarginHeight);
        });

        function grdReadyAction(e) {
            onWindowResize('#gridDeviceProductGroup', settings.GridMarginHeight);
        }

        collapsibleHeaderClickEvent($scope);

        $scope.productsGridExpanded = function () {
            var dataGrid1 = $('#gridProducts').dxDataGrid('instance');
            dataGrid1.repaint();
        };

        $scope.vehiclesGridExpanded = function () {
            var dataGrid1 = $('#gridUnAssignedVehicles').dxDataGrid('instance');
            dataGrid1.repaint();
            var dataGrid2 = $('#gridAssignedVehicles').dxDataGrid('instance');
            dataGrid2.repaint();
        };

        $scope.filter = function (input, id) {
            var i = 0, len = input.length;
            for (; i < len; i++) {
                if (+input[i].Id == +id) {
                    return input[i];
                }
            }
            return null;
        };

        $scope.closeAlert = function () {
            $scope.error = null;
        };

        $scope.closeProductGridAlert = function () {
            $scope.productGridError = null;
        };

        $scope.closeModelStateErrors = function () {
            $scope.modelState = [];
        };

        $scope.clickHalfDiv = function (control) {
            masterFactory.setFocus(control);
        };
    }]);


